import React from 'react';

import { useMst } from '../../models/rootModel';
import { ActionName } from '../../utils/mobileApp/mobileApp.types';

import { PaymentStep } from './PaymentStep/index';
import { PaymentPageStepProps } from './PaymentStep/paymentStep.types';

export const SinglePagePayment = (props: PaymentPageStepProps) => {
  const { UserProgress } = useMst();

  return (
    <>
      {props.isActive ? (
        <PaymentStep
          {...props}
          nextStep={() =>
            UserProgress.goToApp(
              {
                action: ActionName.Added_Payment,
              },
              { nextStep: props.nextStep, totalSteps: props.totalSteps, currentStep: props.currentStep }
            )
          }
        />
      ) : null}
    </>
  );
};
